// extracted by mini-css-extract-plugin
module.exports = {"slashList":"SlashList-module--slash-list--2p-8M"};